import { create } from "zustand";

export type InventoryState = {
  hasHeavyMachineGun: boolean;
  gunMode: boolean;
  isShooting: boolean;
  setHasHeavyMachineGun: (value: boolean) => void;
  setGunMode: (value: boolean) => void;
  setIsShooting: (value: boolean) => void;
  resetInventory: () => void;
};

export const useInventory = create<InventoryState>((set) => ({
  hasHeavyMachineGun: false,
  gunMode: false,
  isShooting: false,
  setHasHeavyMachineGun: (value: boolean) => set({ hasHeavyMachineGun: value }),
  setGunMode: (value: boolean) => set({ gunMode: value }),
  setIsShooting: (value: boolean) => set({ isShooting: value }),
  resetInventory: () => set({ hasHeavyMachineGun: false, gunMode: false, isShooting: false }),
}));
